import {
    LEADS_LIST,
    LEADS_LISTA,
    LEADS_FILTER,
    LEADS_CREATE,
    LEADS_UPDATE,
    LEADS_UPDATE_SUCCESS,
    LEADS_CREATE_SUCCESS,
    LEADS_LIST_SUCCESS,
    LEADS_REQUEST_FAILED,
    LEADS_READ,
    LEADS_READ_SUCCESS,
    LEADS_DELETE,
    LEADS_DELETE_SUCCESS
  } from "./actionTypes";
  
  export const leadsList = () => {
    return {
      type: LEADS_LIST,
      payload: {},
    };
  };
  export const leadsLista = () => {
    return {
      type: LEADS_LISTA,
      payload: {},
    };
  };
  
  export const leadsCreate = (leads) => {
    return {
      type: LEADS_CREATE,
      payload: leads,
    };
  };
  
  export const leadsFilter = (changeUrl) => {
    return {
      type: LEADS_FILTER,
      payload: { changeUrl },
    };
  };
  
  export const leadsRead = (id) => {
    return {
      type: LEADS_READ,
      payload: {id},
    };
  };

  export const leadsReadSuccess = (data) => {
    return {
      type: LEADS_READ_SUCCESS,
      payload: data,
    };
  };
  
  export const leadsUpdate = (id, data) => {
    return {
      type: LEADS_UPDATE,
      payload: { id, data },
    };
  };
  export const leadsDelete = (id) => {
    return {
      type: LEADS_DELETE,
      payload: { id },
    };
  };
  
  export const leadsListSuccess = (leads) => {
    return {
      type: LEADS_LIST_SUCCESS,
      payload: leads,
    };
  };
  
  export const leadsCreateSuccess = (leadsCreated) => {
    return {
      type: LEADS_CREATE_SUCCESS,
      payload: leadsCreated,
    };
  };
  
  export const leadsUpdateSuccess = (leads) => {
    return {
      type: LEADS_UPDATE_SUCCESS,
      payload: leads,
    };
  };
  export const leadsDeleteSuccess = (leads) => {
    return {
      type: LEADS_DELETE_SUCCESS,
      payload: leads,
    };
  };
  
  export const leadsRequestFailed = (error) => {
    return {
      type: LEADS_REQUEST_FAILED,
      payload: error,
    };
  };
  